import type { MembershipStatus } from '../api/payment/membership.api';
import { parseServerDate } from './server-date';

export type JoinAction = 'login' | 'disabled' | 'free' | 'pay' | 'topup';

export const pickJoinAction = (
  status: MembershipStatus | null,
  isLogged: boolean,
): JoinAction => {
  if (!isLogged || !status) return 'login';
  if (!status.enabled) return 'disabled';
  if (status.slot.available) return 'free';
  if (status.topUpBalance < status.payPriceCa) return 'topup';
  return 'pay';
};

/** Hạn hội viên theo giờ Việt Nam, dạng dd/MM. */
export const formatMemberUntil = (iso: string): string => {
  const d = parseServerDate(iso);
  if (!d) return '';
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Ho_Chi_Minh',
    day: '2-digit',
    month: '2-digit',
  }).formatToParts(d);
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '';
  return `${get('day')}/${get('month')}`;
};

export const joinButtonLabel = (
  action: JoinAction,
  status: MembershipStatus,
): string => {
  const verb = status.isMember ? 'Gia hạn' : 'Tham gia';
  if (action === 'free') return `${verb} miễn phí (dùng lượt Cab+ tháng này)`;
  return `${verb} · ${Number(status.payPriceCa || 0).toLocaleString('vi-VN')} Ca/tháng`;
};
